import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import styled from 'styled-components';

const Container = styled.div`
  .modal-dialog {
    width: 90%;
  }
`;

const ContentContainer = styled.div`
  height: 65vh;
  overflow: scroll;
  padding: 80px;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`;

const Content = props =>
  <div style={{padding: "20px 200px", background: '#585858b0'}}>
    <ContentContainer dangerouslySetInnerHTML={{ __html: props.content }}/>
  </div>

const DocumentViewer = (props) => {
  return (
    props.show
    ? <Container className="static-modal">
         <Modal.Dialog>
           <Modal.Header>
             <Modal.Title>{ props.title || "View Document" }</Modal.Title>
           </Modal.Header>

           <Modal.Body>
             <Content {...props}/>
           </Modal.Body>

           <Modal.Footer>
             <Button onClick={ () => { props.hide() } }>Close</Button>
           </Modal.Footer>
         </Modal.Dialog>
      </Container>
      : <div></div>
  )
}

export default DocumentViewer;
